export class HeaderSearch {
	private element: HTMLElement;
	private openButtonElement: HTMLButtonElement;
	private closeButtonElement: HTMLButtonElement;
	private inputElement: HTMLInputElement | null;
	private actionButtonElement: HTMLButtonElement | null;
	private activeClass: string = 'header-search--active';

	constructor(element) {
		if (!element) return;

		this.element = element;
		this.openButtonElement = this.element.querySelector('.header-search__button');
		this.closeButtonElement = this.element.querySelector('.header-search__close');
		this.inputElement = this.element.querySelector('.header-search__input');
		this.actionButtonElement = this.element.querySelector('.header-search__action');

		this.init();
	}

	public open = (): void => this.element.classList.add(this.activeClass);

	public close = (): void => {
		this.element.classList.remove(this.activeClass);
		window.app?.headerSearchResult.close();
	};

	private handleClick = ({ target }): void => {
		if (this.openButtonElement.contains(target)) this.open();
		else if (this.closeButtonElement.contains(target)) this.close();
	};

	private syncActionOpacity = (): void => {
		if (!this.inputElement || !this.actionButtonElement) return;
		const isEmpty = this.inputElement.value.trim().length === 0;
		this.actionButtonElement.classList.toggle('is-empty', isEmpty);
		this.actionButtonElement.toggleAttribute('disabled', isEmpty);
	};

	public init = (): void => {
		this.element.addEventListener('click', this.handleClick);
		this.inputElement?.addEventListener('input', this.syncActionOpacity);
		this.syncActionOpacity();
	};
}
